import { ArrowUpRight } from "lucide-react";
import { BRANDS, CONTACT, IMAGES, JIC_PARTS } from "@/data/content";
import { MaskedLines, Reveal } from "./Reveal";

export const JICSection = () => (
  <section id="jic" className="section section-green jic" data-testid="jic-section">
    <Reveal>
      <p className="mono-label lime">03 / Authorised Master Distributor · India</p>
    </Reveal>

    <div className="jic-head">
      <Reveal delay={0.1} className="jic-badge" data-testid="jic-badge">
        <img src={IMAGES.jicLogo} alt="JIC Hydraulics" className="jic-logo-img" />
      </Reveal>
      <div>
        <MaskedLines as="h2" className="section-title on-dark" lines={["Hydraulic components,"]} data-testid="jic-title" />
        <MaskedLines as="h2" className="section-title on-dark serif-italic" delay={0.12} lines={["supplied with certainty."]} />
        <Reveal delay={0.2}>
          <p className="jic-copy" data-testid="jic-copy">
            AP Enterprises is the authorised master distributor for JIC Hydraulics
            in India. We deal directly with JIC Hydraulics, South Korea — importing
            genuine JIC hydraulic pumps, hydraulic motors, and rotary groups. No
            middlemen. No grey imports.
          </p>
          <a href={`mailto:${CONTACT.emails[0]}?subject=JIC Hydraulics requirement`} className="btn btn-lime" data-testid="jic-cta">
            Discuss your requirement <ArrowUpRight size={16} />
          </a>
        </Reveal>
      </div>
    </div>

    <div className="jic-range">
      <div className="jic-range-head">
        <Reveal>
          <p className="mono-label lime">Component range</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h3 className="jic-range-title">
            Piston pump &amp; motor <em className="serif-italic">rotary groups.</em>
          </h3>
        </Reveal>
      </div>
      <div className="jic-grid">
        {JIC_PARTS.map((r, i) => (
          <Reveal key={i} delay={(i % 3) * 0.08} y={32} className="jic-card" data-testid={`jic-product-${i + 1}`}>
            <div className="jic-card-img">
              <img src={r.img} alt={r.label} loading="lazy" />
            </div>
            <span className="mono-label">{r.label}</span>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1} className="jic-brands" data-testid="jic-brands">
        <p className="mono-label lime">Fitment references</p>
        <p className="jic-brands-list">{BRANDS.join("  ·  ")}</p>
        <p className="jic-disclaimer">
          OEM names and references are for fitment identification purposes only and
          do not imply endorsement, affiliation, or recommendation.
        </p>
        <div className="jic-warning" data-testid="jic-fake-warning">
          <p className="mono-label">⚠ Beware of fake JIC components</p>
          <p>
            Counterfeit "JIC" parts are being sold in India. Verify the source or
            the part with us before you buy — call or WhatsApp our sales team on{" "}
            <a href="tel:+919739402645" data-testid="jic-verify-phone">+91 97394 02645</a>.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
